import React from 'react';
import { Dialog } from '@mui/material';
import CustomerAdd from './ClientAdd';
import CustomerEdit from './ClientEdit';

const ToggleModal = ({
  open,
  toggle,
  isEdit,
  getData,
  data,
  length,
  segments,
  countries,
  setSnackBarOpen,
  setSnackbarSeverity,
  setSnackBarMessage,
  getSegmentData
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      {!isEdit && (
        <CustomerAdd
          toggle={toggle}
          open={open}
          getData={getData}
          getSegmentData={getSegmentData}
          length={length}
          segments={segments}
          countries={countries}
          setSnackBarOpen={setSnackBarOpen}
          setSnackbarSeverity={setSnackbarSeverity}
          setSnackBarMessage={setSnackBarMessage}
        />
      )}
      {isEdit && (
        <CustomerEdit
          toggle={toggle}
          open={open}
          data={data}
          countries={countries}
          getData={getData}
          segments={segments}
          setSnackBarOpen={setSnackBarOpen}
          setSnackbarSeverity={setSnackbarSeverity}
          setSnackBarMessage={setSnackBarMessage}
        />
      )}
    </Dialog>
  );
};

export default ToggleModal;
